import SubcategoryPage from '@/components/template/SubcategoryPage';

const Vanity = () => {
  const products = [
    {
      title: "Vanity Model 1",
      imageSrc: "https://images.unsplash.com/photo-1604014555037-e3abbf2d28b3?auto=format&fit=crop&q=80",
      url: "/ogledala/vanity/model-1"
    },
    {
      title: "Vanity Model 2",
      imageSrc: "https://images.unsplash.com/photo-1513519683267-4ee6636c0a3f?auto=format&fit=crop&q=80",
      url: "/ogledala/vanity/model-2"
    },
    {
      title: "Vanity Model 3",
      imageSrc: "https://images.unsplash.com/photo-1526579353087-90e96bdbd672?auto=format&fit=crop&q=80",
      url: "/ogledala/vanity/model-3"
    },
    {
      title: "Vanity Model 4",
      imageSrc: "https://images.unsplash.com/photo-1616046386594-c152babc9e15?auto=format&fit=crop&q=80",
      url: "/ogledala/vanity/model-4"
    }
  ];

  return (
    <SubcategoryPage
      title="Vanity"
      description="Luksuzna ogledala za toaletne mizice, ki združujejo eleganco in praktičnost. Idealna izbira za vašo kopalnico ali spalnico."
      heroImage="https://images.unsplash.com/photo-1604014555037-e3abbf2d28b3?auto=format&fit=crop&q=80"
      products={products}
    />
  );
};

export default Vanity;